export const getBooleanStatusTranslation = (conditionMet: boolean) => {
  if (conditionMet) {
    return 'common:yes';
  }

  return 'common:no';
};
